import { Link } from "react-router-dom";
import { featuredTopics } from "@/mocks/featured";
import { articles } from "@/mocks/articles";

export default function FeaturedTopics() {
  const colorMap: Record<string, { bg: string; border: string; iconBg: string; iconText: string; tagBg: string; tagText: string }> = {
    primary: { bg: "bg-primary-50/50", border: "border-primary-200/50", iconBg: "bg-primary-100", iconText: "text-primary-600", tagBg: "bg-primary-100/70", tagText: "text-primary-700" },
    accent: { bg: "bg-accent-50/50", border: "border-accent-200/50", iconBg: "bg-accent-100", iconText: "text-accent-600", tagBg: "bg-accent-100/70", tagText: "text-accent-700" },
    secondary: { bg: "bg-secondary-50/50", border: "border-secondary-200/50", iconBg: "bg-secondary-100", iconText: "text-secondary-600", tagBg: "bg-secondary-100/70", tagText: "text-secondary-700" },
  };

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            精选专题
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto leading-relaxed">
            围绕核心场景深度策划，为你提供系统化的指导方案
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featuredTopics.map((topic) => {
            const c = colorMap[topic.color] || colorMap.primary;
            const topicArticles = topic.articles
              .map((id) => articles.find((a) => a.id === id))
              .filter(Boolean);

            return (
              <div
                key={topic.id}
                className={`rounded-xl border ${c.border} ${c.bg} p-6 flex flex-col transition-all duration-300 hover:border-background-300/60`}
              >
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${c.iconBg} mb-4`}>
                  <i className={`${topic.icon} text-xl ${c.iconText}`}></i>
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">
                  {topic.title}
                </h3>
                <p className="text-sm text-foreground-600 mb-5 leading-relaxed flex-1">
                  {topic.subtitle}
                </p>
                <div className="space-y-2">
                  {topicArticles.map((a) => (
                    <Link
                      key={a!.id}
                      to={`/article/${a!.slug}`}
                      className={`block px-3 py-2 rounded-lg text-sm ${c.tagBg} ${c.tagText} hover:opacity-80 transition-opacity cursor-pointer`}
                    >
                      {a!.title}
                    </Link>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}